import React from 'react';
import FractionSimplifier from './components/FractionSimplifier';

function App() {
  return (
    <div className="App">
      <FractionSimplifier />
    </div>
  );
}

export default App;
